<template>
  <ul class="menu-wrapper">
    <li :class="['menu-item', item.active ? 'active' : '']" v-for="item in items" v-if="!item.hide" @click="onChangeMenu(item)">
      <i class="icon" :style="{backgroundImage: 'url(' + (item.active ? item.iconActive : item.icon) + ')'}" />
      {{item.name}}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    items: Array,
  },
  methods: {
    onChangeMenu: function (item) {
      if (!item.active) {
        this.$emit('on-change-menu', item.id)
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-wrapper {
  display: flex;
  align-items: center;
  height: 47px;
  list-style: none;
  border: 1px solid #e51c23;
  font-size: 14px;
  color: #e51c23;
  background-color: #fff;
  margin: 0;
  padding: 0;

  .menu-item {
    width: 0;
    height: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e51c23;

    &:last-child {
      border: 0;
    }

    .icon {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    &.active {
      color: #fff;
      background-color: #e51c23;
    }
  }
}
</style>
